import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import {
  AlertPayload, AlertResponse, AlertIdentificators,
  AlertSearchPayload
} from '@shared/widgets/entities/alerts';

export const createAlertAction = createAction(type('[WIDGETS/ALERTS/API] Create new alert'),
  props<{ payload: AlertPayload }>());
export const createAlertSuccessAction = createAction(type('[WIDGETS/ALERTS/API] Create new alert success'),
  props<{ response: AlertResponse }>());
export const deleteAlertAction = createAction(type('[WIDGETS/ALERTS/API] Delete new alert'),
  props<{ alert: AlertIdentificators }>());
export const deleteAlertSuccessAction = createAction(type('[WIDGETS/ALERTS/API] Delete alert success'));
export const saveSearchAlertAction = createAction(type('[WIDGETS/ALERTS/API] Save search alert'),
  props<{ payload: AlertSearchPayload }>());
export const saveSearchAlertSuccessAction = createAction(type('[WIDGETS/ALERTS/API] Save search alert success'),
  props<{ payload: AlertSearchPayload }>());

export const resetWidgetDataAction = createAction(type('[WIDGETS/ALERTS/DATA] Reset alert widget data'));
export const loadAlertAction = createAction(type('[WIDGETS/ALERTS/DATA] Load alert data'));
export const loadAlertSuccessAction = createAction(type('[WIDGETS/ALERTS/DATA] Load alert data success'),
  props<{ data: AlertResponse }>());

export const setActiveAlertsUIAction = createAction(type('[WIDGETS/UI] Set active alerts action'),
  props<{ payload: boolean }>());
export const closeDeleteToastAction = createAction(type('[WIDGETS/UI] Close delete toast '));
